<template>
  <v-card class="admin-dialog-card admin-confirm-card">
    <div class="admin-confirm-card__icon-wrap">
      <div class="admin-confirm-card__icon">
        <v-icon
          color="white"
          size="28"
        >
          {{ icons.mdiAlertOutline }}
        </v-icon>
      </div>
    </div>

    <v-card-title class="admin-confirm-card__title">
      {{ title }}
    </v-card-title>

    <v-card-text class="admin-confirm-card__body">
      <v-alert
        v-if="errorMessage"
        dense
        outlined
        type="error"
        role="alert"
      >
        {{ errorMessage }}
      </v-alert>
      <strong
        v-if="resolvedItemName"
        class="admin-confirm-card__name"
      >{{ resolvedItemName }}</strong>
      <p class="admin-confirm-card__description">
        {{ resolvedDescription }}
      </p>
      <p
        v-if="resolvedHelperText"
        class="admin-confirm-card__helper"
      >
        {{ resolvedHelperText }}
      </p>
    </v-card-text>

    <v-card-actions class="admin-confirm-card__actions">
      <v-spacer></v-spacer>
      <v-btn
        text
        color="primary"
        :disabled="saving"
        @click="handleClose"
      >
        {{ cancelText }}
      </v-btn>
      <v-btn
        color="error"
        :loading="saving"
        :disabled="saving || disabled || !save"
        @click="handleSave"
      >
        {{ confirmText }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mdiAlertOutline } from '@mdi/js'
import { resolveApiErrorMessage } from '@/utils/apiErrors'

export default {
  name: 'AdminConfirmDialog',
  props: {
    disabled: { type: Boolean, default: false },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    helperText: {
      type: String,
      default: '',
    },
    note: {
      type: String,
      default: '',
    },
    itemName: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    itemId: {
      type: [String, Number],
      default: null,
    },
    confirmText: {
      type: String,
      default: 'Onayla',
    },
    cancelText: {
      type: String,
      default: 'İptal',
    },
    save: {
      type: Function,
      default: null,
    },
    close: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      saving: false,
      errorMessage: '',
      icons: {
        mdiAlertOutline,
      },
    }
  },
  computed: {
    resolvedItemName() {
      if (this.itemName) return this.itemName

      const firstName = this.item?.name || ''
      const lastName = this.item?.surname || ''

      return `${firstName} ${lastName}`.trim()
    },
    resolvedDescription() {
      if (!this.description) return ''
      if (!this.description.includes('{name}')) return this.description

      return this.description.replace('{name}', this.resolvedItemName || 'Bu kaydı')
    },
    resolvedHelperText() {
      return this.helperText || this.note
    },
    resolvedItemId() {
      return this.itemId ?? this.item?.id ?? null
    },
  },
  methods: {
    handleClose() {
      if (this.saving) return
      if (this.close) {
        this.close({})
      }
    },
    async handleSave() {
      if (this.saving || this.disabled || !this.save) return
      this.saving = true
      this.errorMessage = ''
      try {
        const result = await this.save({ id: this.resolvedItemId })
        if (result === false) throw new Error('İşlem tamamlanamadı. Tekrar deneyin.')
        if (this.close) this.close({})
      } catch (error) {
        this.errorMessage = resolveApiErrorMessage(error, 'İşlem tamamlanamadı.')
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
